/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Text } from "@radix-ui/themes";
import { useDropzone } from "react-dropzone";
import { useCallback } from "react";

const DropZone = ({ name, func }) => {
  const onDrop = useCallback((acceptedFiles) => {
    func(name, acceptedFiles);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });
  return (
    <div
      {...getRootProps()}
      style={{
        border: "1px dashed rgba(31, 52, 60, 0.16)",
        padding: "4px",
        textAlign: "center",
        height: "140px",
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "8px",
      }}
    >
      <input name="qwert" {...getInputProps()} />
      <Text size="3" color="gray">
        Drag image here, or click to select files
      </Text>
    </div>
  );
};

export default DropZone;
